/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Paper order type
 */
export enum PaperOrderType {

    Market = 'market',

    Limit = 'limit',

    StopMarket = 'stop_market',

    StopLimit = 'stop_limit',

    TakeProfitMarket = 'take_profit_market',

    TakeProfitLimit = 'take_profit_limit'
}
